<div *transloco="let t;" [ngClass]="sidebarClasses ? sidebarClasses : 'sidebar vstack py-3 bg-secondary overflow-auto'">

  @if (checkPermission('dashboard')) {
    <div [routerLinkActive]="'active'" [routerLink]="['dashboard']"
      class="sidebar-menu"
      role="button">
      <div class="sidebar-item-content">
        <i class="icon-chart"></i>
        <span>{{ t('components.sidebar.dashboard') }}</span>
      </div>
    </div>
  }

  <!-- Users dropdown -->
  @if (checkPermission('users')) {
    <div>
      <div (click)="userCollapse.toggle()"
        class="sidebar-menu" role="button">
        <div class="sidebar-item-content">
          <i class="icon-users"></i>
          {{ t('entities.users') }}
          <i [class.open]="!userIsCollapsed" class="icon-arrow-down dropdown-icon"></i>
        </div>
      </div>
      <div #userCollapse="ngbCollapse" [(ngbCollapse)]="userIsCollapsed">
        @if (checkPermission('users')) {
          <a [routerLinkActive]="'active'" [routerLink]="['users']" class="sidebar-item"
            role="button">
            <div class="sidebar-item-content">
              <i class="icon-circle-small text-decoration-none"></i>
              <span>{{ t('components.sidebar.activeUsers') }}</span>
            </div>
          </a>
        }
        @if (checkPermission('approve-users')) {
          <a [routerLinkActive]="'active'" [routerLink]="['approve-users']"
            class="sidebar-item"
            role="button">
            <div class="sidebar-item-content">
              <i class="icon-circle-small text-decoration-none"></i>
              <span>{{ t('components.sidebar.guests') }}</span>
              <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('approve-users') }}</span>
            </div>
          </a>
        }
      </div>
    </div>
  }

  @if (checkPermission('reports')) {
    <div [routerLinkActive]="'active'" [routerLink]="['reports']" class="sidebar-menu"
      role="button">
      <div class="sidebar-item-content">
        <i class="icon-file-lines"></i>
        <span>{{ t('components.sidebar.reports') }}</span>
      </div>
    </div>
  }

  @if (checkPermission('marketplace')) {
    <div [routerLinkActive]="'active'" [routerLink]="['marketplace']" class="sidebar-menu d-none"
      role="button">
      <div class="sidebar-item-content">
        <i class="icon-credit-card"></i>
        <span>Marketplace</span>
      </div>
    </div>
  }

  @if (checkPermission('templates')) {
    <a [routerLinkActive]="'active'" [routerLink]="['templates']"
      class="sidebar-menu d-none"
      role="button">
      <div class="sidebar-item-content">
        <i class="icon-copy"></i>
        <span>{{ t('components.sidebar.templates') }}</span>
      </div>
    </a>
  }

  <!--   Farm dropdown   -->
  @if (checkPermission('farms')) {
    <div>
      <div (click)="collapse.toggle()"
        class="sidebar-menu" role="button">
        <div class="sidebar-item-content">
          <i class="icon-tractor"></i>
          {{ t('components.sidebar.farmsDropdown') }}
          <i [class.open]="!farmsIsCollapsed" class="icon-arrow-down dropdown-icon"></i>
        </div>
      </div>
      <div #collapse="ngbCollapse" [(ngbCollapse)]="farmsIsCollapsed">
        <a [routerLinkActive]="'active'" [routerLink]="['farms']" class="sidebar-item"
          role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.farms') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('farms') }}</span>
          </div>
        </a>
        <a [routerLinkActive]="'active'" [routerLink]="['groups']" class="sidebar-item"
           role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.groups') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('groups') }}</span>
          </div>
        </a>
      </div>
    </div>
  }

  <!-- Field -->
  @if (checkPermission('fields')) {
    <div>
      <div (click)="collapse.toggle()"
        class="sidebar-menu" role="button">
        <div class="sidebar-item-content">
          <i class="icon-wheat"></i>
          {{ t('entities.fields') }}
          <i [class.open]="!fieldsIsCollapsed" class="icon-arrow-down dropdown-icon"></i>
        </div>
      </div>
      <div #collapse="ngbCollapse" [(ngbCollapse)]="fieldsIsCollapsed">
        <a [routerLinkActive]="'active'" [routerLink]="['fields']" class="sidebar-item"
          role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.fields') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('fields') }}</span>
          </div>
        </a>
        <a [routerLinkActive]="'active'" [routerLink]="['fieldActions']" class="sidebar-item"
          role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.actions') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('fieldActions') }}</span>
          </div>
        </a>
        <a [routerLinkActive]="'active'" [routerLink]="['cows']" class="sidebar-item d-none"
           role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.cows') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('cows') }}</span>
          </div>
        </a>
      </div>
    </div>
  }

  <!--   Production dropdown   -->
  @if (checkPermission('production')) {
    <div>
      <div (click)="collapse.toggle()"
           class="sidebar-menu" role="button">
        <div class="sidebar-item-content">
          <i class="icon-industry"></i>
          {{ t('components.sidebar.production') }}
          <i [class.open]="!productionIsCollapsed" class="icon-arrow-down dropdown-icon"></i>
        </div>
      </div>
      <div #collapse="ngbCollapse" [(ngbCollapse)]="productionIsCollapsed">
        <a [routerLinkActive]="'active'" [routerLink]="['lots']" class="sidebar-item"
           role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.lots') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('lots') }}</span>
          </div>
        </a>
      </div>
    </div>
  }

  <!-- Livestock -->
  @if (checkPermission('livestock')) {
    <div>
      <div (click)="collapse.toggle()"
        class="sidebar-menu" role="button">
        <div class="sidebar-item-content">
          <i class="icon-clipboard-list"></i>
          {{ t('components.sidebar.livestock') }}
          <i [class.open]="!livestockIsCollapsed" class="icon-arrow-down dropdown-icon"></i>
        </div>
      </div>
      <div #collapse="ngbCollapse" [(ngbCollapse)]="livestockIsCollapsed">
        <a [routerLinkActive]="'active'" [routerLink]="['actions']" class="sidebar-item"
          role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.actions') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('actions') }}</span>
          </div>
        </a>
        <a [routerLinkActive]="'active'" [routerLink]="['documents']" class="sidebar-item"
          role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.documents') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('documents') }}</span>
          </div>
        </a>
        <a [routerLinkActive]="'active'" [routerLink]="['scheduledPlans']" class="sidebar-item"
          role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.scheduledPlans') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('scheduledPlans') }}</span>
          </div>
        </a>
        <a [routerLinkActive]="'active'" [routerLink]="['scheduledInstances']"
          class="sidebar-item" role="button">
          <div class="sidebar-item-content">
            <i class="icon-circle-small"></i>
            <span>{{ t('entities.scheduledInstances') }}</span>
            <span class="badge text-bg-primary text-white ms-auto">{{ counterMap.get('scheduledInstances') }}</span>
          </div>
        </a>
      </div>
    </div>
  }

  @if (checkPermission('analysis')) {
    <div [routerLinkActive]="'active'" [routerLink]="['analysis']"
      class="sidebar-menu"
      role="button">
      <div class="sidebar-item-content">
        <i class="icon-flask"></i>
        <span>{{ t('entities.analysis') }}</span>
      </div>
    </div>
  }

  @if (checkPermission('options')) {
    <div [routerLinkActive]="'active'" [routerLink]="['config']"
      class="sidebar-menu"
      role="button">
      <div class="sidebar-item-content">
        <i class="icon-gear"></i>
        <span>{{ t('global.options') }}</span>
      </div>
    </div>
  }

</div>
